import styled from 'styled-components';

export const ScrollWrapper = styled.div`
	overflow-y: auto;
	height: 100%;
	width: 100%;
`;

export const ContentContainer = styled.div`
	padding: 56px 64px;
	max-width: 720px;
	margin: 0 auto;
`;

export const GuidelineHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 24px;
`;

export const GuidelineTitle = styled.h1`
	font-size: 24px;
	font-weight: 600;
	margin: 0;
	color: ${({ theme }) => theme.gray[1000]};
`;
